import React, { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const PageWrapperDiv = styled.div`
  padding: 10px;
  background-color: #f8f8f8;
  height: 100%;

  @media (min-width: ${ScreenSize.md}px) {
    border-radius: 10px;
    margin-right: 20px;
    padding: 20px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  border-style: solid;
  padding: 20px;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: ${ScreenSize.md}px) {
    padding: 16px;
  }
`;

const PageWrapper: FC<PropsWithChildren<any>> = ({ children }) => {
  return (
    <PageWrapperDiv>
      <Content>{children}</Content>
    </PageWrapperDiv>
  );
};
export default PageWrapper;
